import { Input } from 'form-components/components/Input/Input'
import { Select } from 'form-components/components/Select/Select'
import type { OptionsType } from 'fukku/Select/Select'
import { FIELD_COMPONENTS } from 'refunds/constants/FieldComponents'
import type { FormField } from 'refunds/services/getCountryFields/normalization'
import { cx } from 'utils/cx'

import styles from './MultiInput.module.scss'

interface MultiInputProps {
	readonly fieldConfig: FormField
	readonly fieldData?: OptionsType[]
}

export function MultiInput({ fieldConfig, fieldData }: MultiInputProps) {
	const {
		field,
		component,
		label,
		labelFocused,
		errorLabel,
		validation,
		hintMessage,
		forceUpperCase,
		required,
		maxLength,
	} = fieldConfig

	/**
	 * Regex can't be passed from server to client so we must create RegExp instance here and
	 * pass /u modifier as it is needed for these forms' validations.
	 */
	const validationRegex = validation ? new RegExp(validation, 'u') : validation
	const fieldId = `refunds.bankData.form.${field}`

	if (component === FIELD_COMPONENTS.SELECT && fieldData) {
		return (
			<Select
				id={fieldId}
				name={field}
				data-testid={fieldId}
				label={label}
				hintMessage={hintMessage}
				errorMessage={errorLabel}
				options={fieldData}
				rules={{ required }}
			/>
		)
	}

	return (
		<Input
			id={fieldId}
			name={field}
			className={cx(forceUpperCase && styles.upperCase)}
			data-testid={fieldId}
			label={label}
			labelFocused={labelFocused}
			hintMessage={hintMessage}
			errorMessage={errorLabel}
			type={component === FIELD_COMPONENTS.DATE_INPUT ? 'date' : 'text'}
			rules={{
				maxLength,
				required,
				regex: validationRegex,
			}}
		/>
	)
}
